const _window = $(window);
const body = $('body');
import {goToByScroll} from './go-to-by-scroll';
import {scrollPos} from './check-scroll';


/**
 * Safari browser detection
 * @type {boolean}
 */
const is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

if (is_safari)
{
	body.addClass('is-safari');
}


/**
 * Open hidden fields when the e-mail field in the "Maichimp for Wordpress" wigdet gains focus
 */
$('input[type=email]', '#site-footer .mc4wp-form').on('focus', function () {
	$('.hidden-fields', '#site-footer .mc4wp-form').slideDown();
});


$('.mc4wp-form .btn').on('click', function () {
	if ($('input[name=AGREE_TO_TERMS]').prop('checked') !== true)
	{
		$('.mc4wp-form .privacy label').addClass('error');
	}
	else
	{
		$('.mc4wp-form .privacy label').removeClass('error');
	}
});


$('input[name=AGREE_TO_TERMS]').on('click', function () {
	if ($(this).prop('checked') !== true)
	{
		$('.mc4wp-form .privacy label').addClass('error');
	}
	else
	{
		$('.mc4wp-form .privacy label').removeClass('error');
	}
});

let heroHomeScrollDown = $('.hero-home__scroll-down');

if (heroHomeScrollDown.length > 0)
{
	let heroHomeHeight;
	let heroHomeHighlights = $('.hero-home__highlights');

	setHeroHomeHeight();
	setHeroHomeElementsPosition();

	function setHeroHomeHeight() {
		heroHomeHeight = $('.hero-home').outerHeight() + $('#header').outerHeight() - _window.height();
	}

	function setHeroHomeElementsPosition() {
		if (scrollPos < heroHomeHeight)
		{
			heroHomeScrollDown.css('bottom', heroHomeHeight - scrollPos);
			heroHomeHighlights.css('bottom', heroHomeHeight - scrollPos);
		}
		else
		{
			heroHomeScrollDown.removeAttr('style');
			heroHomeHighlights.removeAttr('style');
		}

		requestAnimationFrame(() => setHeroHomeElementsPosition());
	}

	_window.on('resizeEnd', function () {
		setHeroHomeHeight();
	});

	heroHomeScrollDown.on('click', function () {
		goToByScroll($('.sezione-1'));
	});
}


let appartementi = $('.appartamento', '.sezione-appartamenti');
let n_appartementi = appartementi.length;

let z = n_appartementi;
appartementi.each(function (){
	$(this).css('z-index', z--);
});

appartementi.on('click', function (e) {

	let index = $(this).index();

	for (let i = 0; i < index; i++)
	{
		appartementi.eq(i).addClass('moved');
	}

	for (let j = index; j < n_appartementi; j++)
	{
		appartementi.eq(j).removeClass('moved');
	}

	$(this).siblings().removeClass('active');

	// go to page on second click
	if ($(this).hasClass('active'))
	{
		location.href = $(this).find('a').attr('href');
	}
	else
	{
		$(this).addClass('active');
		return false;
	}
});


$('.swiper-button-prev, .swiper-button-next', '.sezione-appartamenti').on('click', function (){
	let direction = $(this).hasClass('swiper-button-next')? 'next' : 'prev';

	let firstAppartamento = appartementi.filter(':first-child');
	let position = $('.sezione-appartamenti').attr('data-position');

	if (direction === 'next' && position < n_appartementi - 4)
	{
		position++;
	}
	else if (direction === 'prev' && position > 0)
	{
		position--;
	}

	$('.swiper-button-prev, .swiper-button-next', '.sezione-appartamenti').removeClass('swiper-button-disabled');

	if (position === 0 || position === n_appartementi - 4)
	{
		$(this).addClass('swiper-button-disabled');
	}


	$('.sezione-appartamenti').attr('data-position', position);

	firstAppartamento.css('margin-left', -18 * position + '%')
});




/**
 * ON LOAD
 */

_window.on('load', function (event) {

});



/**
 * ON RESIZE
 */

_window.on('resize', function (event) {

	if (event.target === window)
	{
		// trigger resizeEnd event only when the window resizing ends
		if (this.resizeTO)
		{
			clearTimeout(this.resizeTO);
		}
		this.resizeTO = setTimeout(function () {
			$(this).trigger('resizeEnd');
		}, 200);
	}

});



/**
 * ON RESIZE END
 */

// do something when the window resizing ends
_window.on('resizeEnd', function () {

});



/**
 * ON SCROLL
 */
/*window.addEventListener('scroll', function() {
});*/